import FooterLinks from "./footerLinks";
import verifyImage from '../../assets/image.svg';

const ConsentAndDisclosureGroup1 = (props) => {
    const { onVerifyClearHandler, user, displayData } = props;
return (
    <>
    <div className="consent-disclosure white-box consent-disclosure-usa">
        <div className="consent-disclosure-header">Biometric Identity Verification Through CLEAR
<br/>Consent Disclosure</div>
<div className="consent-disclosure-description">
    {displayData[0]?.consent_language}
</div>
    </div>
        <div className="white-box">
              <button
                className="verify-button"
                id="verify_button_d"
                type="button"
                onClick={()=> onVerifyClearHandler(displayData[0]?.consent_id)}
              >
                <img src={verifyImage} alt="Verify with CLEAR" />
                {
                    displayData[0]?.button_text_inner
                }
              </button>
            </div>
            <div className="white-box">
                <div
                className={`${
                 user.errorMessage ? 'outcome-box-exit' : 'outcome-box-greyed'
               }`}
                id="outcome_box"
              >
                Not yet verified
              </div>
              <FooterLinks user={user} />
            </div>
    </>
)
}

export default ConsentAndDisclosureGroup1;